module.exports = __webpack_public_path__ + "img/6-Integras-Roadside-Information-Page-MVP.a87a413c.png";